export default "__VITE_ASSET__5839a8bc__"